import React from 'react'
import { Box, Typography } from '@mui/material'

import {
  UI_COLOR_BORDER_NEUTRAL,
  UI_COLOR_TEXT_DIALOG_LABEL,
  UI_COLOR_TEXT_DIALOG_VALUE
} from '../../../../constants/uiColors'

const RefundApprovalSummaryRows = ({ items, showLastBorder = false }) =>
  items.map((item, index) => (
    <Box
      key={item.label}
      sx={{
        minHeight: 34,
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        alignItems: 'center',
        gap: 2,
        borderBottom:
          showLastBorder || index < items.length - 1
            ? `1.5px solid ${UI_COLOR_BORDER_NEUTRAL}`
            : 'none'
      }}
    >
      <Typography sx={{ color: UI_COLOR_TEXT_DIALOG_LABEL, fontSize: 14 }}>{item.label}</Typography>
      <Typography
        sx={{
          color: UI_COLOR_TEXT_DIALOG_VALUE,
          fontSize: 14,
          fontWeight: 700,
          textAlign: 'right',
          overflowWrap: 'anywhere'
        }}
      >
        {item.value}
      </Typography>
    </Box>
  ))

export default RefundApprovalSummaryRows
